export default {
  INVESTMENT_PRODUCTS_REPOSITORY: Symbol.for('INVESTMENT_PRODUCTS_REPOSITORY'),
  GET_INVESTMENT_PRODUCTS_QUERY: Symbol.for('GET_INVESTMENT_PRODUCTS_QUERY'),
  INVESTMENT_PRODUCTS_STATE_MANAGER: Symbol.for('INVESTMENT_PRODUCTS_STATE_MANAGER'),
};
